import { Accordion, AccordionDetails, AccordionSummary, Divider, IconButton } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import PrintOutlinedIcon from '@material-ui/icons/PrintOutlined';
import { BadgeChipX } from 'framework/components/chips/BadgeChipX';
import { SearchbarX } from 'framework/components/search/SearchbarX';
import { useApiEffect } from 'framework/hooks/useApiEffect';
import { useLazyEffect } from 'framework/hooks/useLazyEffect';
import { getCochlearPartnerTrainingModules_handle, ICochlearPartnerTrainingModuleDto } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import _ from 'lodash';
import React, { useState } from 'react';
import { useDialogsContext } from 'shared/dialogs/useDialogsContext';
import { IReloadTriggerProps } from 'shared/layout/IReloadTriggerProps';
import { MediaAssetsCarousel, MediaAssetsCarouselDialog } from './cochlear.components';

type CochlearPartnerTrainingTabProps = IReloadTriggerProps & {
	reload: VoidFunction;
};

export const CochlearPartnerTrainingTab = ({ reloadTrigger }: CochlearPartnerTrainingTabProps) => {
	const strings = useLocalization();
	const [data, reloadEvents] = useApiEffect(getCochlearPartnerTrainingModules_handle);
	const [search, setSearch] = useState<string>('');
	var fOrderedData = _.orderBy(
		(data ?? []).filter(t => t.title?.toLowerCase().includes(search)),
		t => t.order
	);
	const { open, confirm } = useDialogsContext();
	// const [expandedIds, setExpandedIds] = useState<string[]>([]);

	useLazyEffect(() => {
		reloadEvents();
	}, [reloadTrigger]);

	const openDialog = (item: ICochlearPartnerTrainingModuleDto) => {
		open(
			<MediaAssetsCarouselDialog
				assets={item.mediaAssets}
				close={confirm}
			/>
		);
	};

	if (data === undefined) {
		return <div></div>;
	}

	return (
		<div
			className='df-col gap-8 w100'
			style={{ padding: '16px' }}>
			<div className='df-row-ac gap-8 w100'>
				<SearchbarX
					placeholder={strings.searchVerb}
					value={search}
					onSearch={val => setSearch(val)}
					style={{ width: 500, height: 36 }}
				/>
				<div className='fg1'></div>
				<IconButton
					size='small'
					color='primary'
					onClick={() => {}}>
					<GetAppOutlinedIcon />
				</IconButton>
				<IconButton
					size='small'
					color='primary'
					onClick={() => {}}>
					<PrintOutlinedIcon />
				</IconButton>
				<IconButton
					size='small'
					color='primary'
					onClick={() => {}}>
					<MailOutlineIcon />
				</IconButton>
			</div>
			<Divider />
			{fOrderedData.length === 0 && <em>{strings.noResultsCommaChangeFilterParams}</em>}
			<div className='df-col'>
				{fOrderedData.map(t => (
					<Accordion key={t.id}>
						<AccordionSummary expandIcon={<ExpandMoreIcon />}>
							<div className='df-row-ac gap-8'>
								<BadgeChipX
									value={t.order}
									color='primary'
								/>
								<div style={{ fontWeight: 600 }}>{t.title}</div>
							</div>
						</AccordionSummary>
						<AccordionDetails>
							<div className='df-col'>
								<div
									dangerouslySetInnerHTML={{
										__html: t.htmlContent ?? '',
									}}
								/>
								<MediaAssetsCarousel
									assets={t.mediaAssets}
									openDialog={() => openDialog(t)}
									variant='embedded'
								/>
							</div>
						</AccordionDetails>
					</Accordion>
				))}
			</div>
		</div>
	);
};
